export const CHANGE_CONTACT_FIELD = 'CHANGE_CONTACT_FIELD'
export const RESET_CONTACT = 'RESET_CONTACT'
export const COMPANIES_FETCH_REQUESTED = 'COMPANIES_FETCH_REQUESTED'
export const SET_CONTACT = 'SET_CONTACT'
